import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import ReportItem from './ReportItemModel';

const ReportLineRecord = Record({
  classification: '',
  value: 0,
  charts: [],
});

export default class ReportLine extends ReportLineRecord {
  static deserialize(jsonObject) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {
      charts: Hydrator.fromArray(ReportItem.deserialize),
      classification: (classification) => classification.toLowerCase(),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new ReportLine(hydrated);
  }
}
